/* eslint-disable @typescript-eslint/no-var-requires */
const intlCentroids = require('./centroids_international_comp.json');
const usCentroids = require('./centroids_us_comp.json');

window.usCentroids = usCentroids;
window.intlCentroids = intlCentroids;
